<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="invoice-page">
    <div v-if="boleto.length == 0" class="alert alert-danger text-center">
      Nenhum boleto encontrado
    </div>

    <div
      v-else
      :class="`${insideApp == true ? 'bg-white p-2' : 'quebraPagina'}`"
    >
      <boleto :dados="boleto[0].dadosToBoleto"></boleto>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import service from "./../../services";
import moment from "moment";
import vSelect from "vue-select";
import locale from "./../../locale";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import pdf from "vue-pdf";
import boleto from "./../Includes/boleto.vue";
export default {
  data() {
    return {
      carregando: true,
      boleto: [],
      logo: "https://bboneapp.s3.amazonaws.com/evo-gerencial-color.png",
      totalImagensCarregadas: 0,
      insideApp: this.$route.query.insideApp,
    };
  },
  methods: {
    setViewport: function () {
      let changeWindowSize = 375;
      let viewportContent = "width=device-width,initial-scale=1.0";
      if (window.innerWidth <= changeWindowSize) {
        viewportContent = "width=1024";
      }
      console.log(window.innerWidth, viewportContent);
      document
        .querySelector("meta[name='viewport']")
        .setAttribute("content", viewportContent);
    },
    buscaDadosToImpressao() {
      var objSend = {};
      objSend.idRegistroFinanceiro = this.$route.params.idRegistroFinanceiro;
      objSend.nossoNumero = this.$route.params.nossoNumero;

      this.$vs.loading();
      service
        .post("Boletos", "buscarDadoToImpressao", objSend)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          res.data.forEach((element) => {
            element.dadosPagador = JSON.parse(element.dadosPagador);
            element.dadosPagador = element.dadosPagador[0];

            element.dadosEmpresa = JSON.parse(element.dadosEmpresa);
            element.dadosEmpresa = element.dadosEmpresa[0];
            console.log(element.dadosEmpresa);

            var dadosGalax = JSON.parse(element.retornoApi);
            dadosGalax = dadosGalax.Charge ? dadosGalax.Charge : dadosGalax;
            console.log(dadosGalax);

            var dadosToBoleto = {
              dadosEmpresa: {
                nome: element.dadosEmpresa.RazaoSocial,
                cpfcnpj: element.dadosEmpresa.cnpj,
                endereco: element.dadosEmpresa.endereco,
                numero: element.dadosEmpresa.numero,
                complemento: element.dadosEmpresa.complemento,
                bairro: element.dadosEmpresa.bairro,
                cidade: element.dadosEmpresa.cidade,
                estado: element.dadosEmpresa.estado,
                cep: element.dadosEmpresa.cep,
                logo: element.dadosEmpresa.logo,
              },
              dadosPagador: {
                nome: element.dadosPagador.nome,
                cpfcnpj: element.dadosPagador.cpfcnpj,
                endereco: element.dadosPagador.endereco,
                numero: element.dadosPagador.numero,
                complemento: element.dadosPagador.complemento,
                bairro: element.dadosPagador.bairro,
                cidade: element.dadosPagador.cidade,
                estado: element.dadosPagador.estado,
                cep: element.dadosPagador.cep,
              },
              dadosCobranca: {
                id: element.id_boleto,
                descricao: dadosGalax.PaymentMethodBoleto.instructions,
                dataVencimento: dadosGalax.Transactions[0].payday,
                dataEmissao: dadosGalax.Transactions[0].createdAt,
                valor: parseInt(dadosGalax.Transactions[0].value) / 100,
                nossoNumero: dadosGalax.Transactions[0].Boleto.bankNumber,
                instrucao: `Este boleto pode ser pago em qualquer banco, mesmo que vencido, desde que não ultrapasse ${dadosGalax.PaymentMethodBoleto.deadlineDays} dia(s) da data do vencimento
  (sujeito a multa e juros)`,
                linhaDigitavel: dadosGalax.Transactions[0].Boleto.bankLine,
                barCode: dadosGalax.Transactions[0].Boleto.barCode,
                banco: dadosGalax.Transactions[0].Boleto.bankEmissor,
                multa: parseInt(dadosGalax.PaymentMethodBoleto.fine) / 100,
                juros: parseInt(dadosGalax.PaymentMethodBoleto.interest) / 100,
                pix: dadosGalax.Transactions[0].Pix
                  ? dadosGalax.Transactions[0].Pix.qrCode
                  : null,
              },
            };
            console.log(dadosToBoleto);
            element.dadosToBoleto = dadosToBoleto;
            this.boleto.push(element);
          });
          console.log(this.boleto);
        })
        .catch((e) => {
          console.log(e);
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Erro ao Buscar Boleto",
            color: "danger",
          });
        });
    },
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
    this.buscaDadosToImpressao();
    this.setViewport();
  },
  components: {
    boleto,
  },
};
</script>
<style>
.div1,
.div2,
.div3 {
  height: calc(290mm / 3);
  margin: 5px;
}
table td,
table td * {
  vertical-align: top;
}
@page {
  margin: 0;
}
body {
  margin: 0;
}
.sheet {
  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
}
.quebraPagina {
  page-break-after: always;
  width: 210mm;
  padding: 5px 10px 5px 15px;
}

/** Paper sizes **/
.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}
.A4 .sheet {
  width: 210mm;
  height: 296mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}
.A5 .sheet {
  width: 148mm;
  height: 209mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}

/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin: 5mm;
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
</style>
<style lang="scss">
.wrapper {
  width: 100%;
  min-height: 250px;
  position: relative;
  padding: 15px;
  color: rgba(black, 0.5);
  font-size: small;
  display: inline-block;
  height: calc(290mm / 3);
  .invertida {
    transform: rotate(-180deg);
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
  }
  .content {
    //margin-top: 60px;
    margin-right: 100px;
    .box {
      padding: 20px;
      border: 1px solid black;
      width: 80%;
      color: black;
    }
  }
  h3 {
    font-size: 1rem;
    text-transform: uppercase;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: -100px;
    margin-bottom: 160px;
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
  }
}

.wrapper2 {
  width: 100%;
  min-height: 250px;
  position: relative;
  border-left: 40px solid transparent;
  padding: 15px;
  color: rgba(black, 0.5);
  font-size: small;
  display: inline-block;
  height: calc(290mm / 3);
  .content {
    background-color: #ccc;
    height: 258px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .box {
      width: 500px;
      height: 150px;
      background: #fff;
      border: 1px solid black;
      border-radius: 30px;
      padding: 20px;
      color: black;
    }
  }
  .box2 {
    width: 100%;
    background: #fff;
    border: 1px solid black;
    color: black;
  }
  h3 {
    font-size: 1rem;
    text-transform: uppercase;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: -160px;
    margin-top: 160px;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    span {
      font-size: 9px;
      margin-left: 45px;
    }
  }
}
</style>

<style lang="scss">
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .table-bordered {
    tr:nth-child(2n) {
      background-color: #ffffff !important;
    }
  }
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}
</style>
